import React from 'react';
import PropTypes from 'prop-types';


const TextPhonenumber = ({ value, className }) => {   

  let phonenumber = value;
  if(phonenumber === undefined || phonenumber === null) phonenumber = "";
  if(!phonenumber.includes('-'))
  {
    phonenumber = phonenumber.substr(0, 3) + '-' + phonenumber.substr(3);   
  }
  let telLink = "tel:+" + value;
    return (
        <a className={className} href={telLink}>{phonenumber}</a>        
      );
};

TextPhonenumber.propTypes = {
  value: PropTypes.string,  
  className : PropTypes.string  
};

export default TextPhonenumber;
